<template>
  <div :class="['grid-adress-content','grid-content1',choseIdx === addressItem.id ?'grid-active':'']"  @click="choseOne(addressItem)">
    <img v-if="addressItem.isDefault === 1" class="choseImg" src="@/assets/images/new-ui/addressleft.png" alt="">
      <div class="justify-between">
        <div class="consignee-name"> {{ addressItem.name }}</div>
        <div class="btn" @click.stop="edit(addressItem.id)">修改</div>
      </div>
      <div class="consignee-tel">
        {{ addressItem.contactPhone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2") }}
      </div>
      <tooltip :rows="2" :content="`${addressItem.province }${ addressItem.city }${ addressItem.district }${ addressItem.address }`"></tooltip>
    </div>
</template>

<script>
import tooltip from "@/components/tooltip.vue";

export default {
  name: "", // 角色管理
  components: { tooltip },
  data () {
    return {
    };
  },
  props: {
    addressItem:{
        type: Object,
        default:()=>{}
      },
      choseIdx:{
        type: String,
        default:()=>''
      },
    },
    watch:{
      choseIdx:{
            handler(val){
                console.log('=====',this.FakuformInfo)
                this.Fakuform={...this.FakuformInfo}
            }
        }
    },
  async mounted() {
  },
  methods: {
    choseOne (item) {
      this.$emit('choseOne', item)
    },
    edit (id) {
       this.$emit('edit',id)
    },

  },
};
</script>
<style lang="scss" scoped>
.flex-box {
  display: flex;
}

.align-center {
  align-items: center;
}

.dialog-title {
  font-size: 36px;
  color: #B0B0B0;
  margin-bottom: 20px;
}

.container {
  background: #FFFFFF;
  padding: 0;
  font-family: "微软雅黑", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  color: #333333;
  box-sizing: content-box;

  .title {
    margin-top: 42px;
    font-size: 36px;
    color: #B0B0B0
  }

  .address-content {
    display: flex;
    flex-wrap: wrap;
    .btn {
          width: 40px;
          margin: 0 10px;
          color: $blue;
          cursor: pointer;
          text-align: right;
        }
      }
}
</style>
